import React, { useState } from 'react';

import { Echange } from '@randstad-lean-mobile-factory/react-assets/dist/headers';
import { ServerErrorRed } from '@randstad-lean-mobile-factory/react-assets/dist/illustrations';
import {
  Alert,
  Button,
  Loader,
  Modal,
  ModalActions,
  ModalContent,
  WithLightTitle,
} from '@randstad-lean-mobile-factory/react-components-core';

import SearchableDropDown from '../../../Components/SearchableDropDown';
import { useAddAgenciesToOnCallCenter } from '../../../Hooks/OnCallCenters/useAddAgenciesToOnCallCenter';
import { useFetchOnCallCenters } from '../../../Hooks/OnCallCenters/useFetchOnCallCenters';
import { OnCallCenterDto, UpdateOnCallCenterBody } from '../../../Services/API';

import styles from './AddToOnCallCenterModal.module.scss';
import { Props } from './AddToOnCallCenterModal.types';

const AddToOnCallCenterModalComponent = ({
  isOpen,
  setIsOpen,
  agencies,
  setOnCallCenterAgencies,
}: Props) => {
  const { data: onCallCenters, isLoading, isSuccess } = useFetchOnCallCenters({ enabled: isOpen });
  const [selectedOnCallCenter, setSelectedOnCallCenter] = useState<OnCallCenterDto>();
  const onClose = () => {
    addAgenciesToOnCallCenterMutation.reset();
    setSelectedOnCallCenter(undefined);
    setOnCallCenterAgencies([]);
    setIsOpen(false);
  };

  const addAgenciesToOnCallCenterMutation = useAddAgenciesToOnCallCenter();

  return (
    <Modal size="medium" open={isOpen} onClose={() => setIsOpen(false)}>
      <ModalContent title="rattacher à une permanence" header={<Echange />}>
        {isLoading ? (
          <Loader size="medium" variant="primary" />
        ) : isSuccess ? (
          <div className={styles.mainContainer}>
            <WithLightTitle title="unités sélectionnées">
              <p className={styles.agencyList}>
                {agencies.map(agency => agency.agencyId).join(', ')}
              </p>
            </WithLightTitle>
            <WithLightTitle title="trouver la permanence à laquelle rattacher la ou les unité(s) sélectionnées">
              <SearchableDropDown
                items={onCallCenters}
                selectedItem={selectedOnCallCenter}
                keyValueExtractor={item => {
                  return {
                    key: item.onCallCenterId,
                    label: item.onCallCenterId,
                    value: item.onCallCenterId,
                    item,
                  };
                }}
                onSelectItem={item => {
                  if (!item) return;
                  setSelectedOnCallCenter(item);
                }}
                placeholder="choisir une permanence"
              />
            </WithLightTitle>
          </div>
        ) : (
          <ServerErrorRed />
        )}
      </ModalContent>
      {(selectedOnCallCenter?.agencies.length ?? 0) + agencies.length > 50 && (
        <div className={styles.alertContainer}>
          <Alert variant="error">
            vous avez atteint le nombre maximum d'unités rattachées à une permanence, veuillez
            contacter l'assistance
          </Alert>
        </div>
      )}
      <ModalActions side="right">
        <Button variant="secondary" onClick={onClose}>
          annuler
        </Button>
        <Button
          variant="primary"
          type="submit"
          mutationStatus={addAgenciesToOnCallCenterMutation.status}
          onClick={() => {
            addAgenciesToOnCallCenterMutation.mutate(
              {
                onCallCenterId: selectedOnCallCenter?.onCallCenterId,
                agencies: agencies,
              } as UpdateOnCallCenterBody,
              {
                onSuccess: () => {
                  setTimeout(() => onClose(), 500);
                },
                onError: () => {
                  setTimeout(() => addAgenciesToOnCallCenterMutation.reset(), 500);
                },
              }
            );
          }}
          disabled={
            (selectedOnCallCenter?.agencies.length ?? 0) + agencies.length > 50 ||
            !selectedOnCallCenter
          }
        >
          valider
        </Button>
      </ModalActions>
    </Modal>
  );
};

export default AddToOnCallCenterModalComponent;
